// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class MedicalBiTransportationService {
    'isCovered'?: string;
    'phoneNumber'?: string;
    'isLodgingCovered'?: string;
    'lodgingServicePhoneNumber'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof MedicalBiTransportationService>> = [
        {
            "name":     "isCovered",
            "baseName": "isCovered",
            "type":     "string"
        },
        {
            "name":     "phoneNumber",
            "baseName": "phoneNumber",
            "type":     "string"
        },
        {
            "name":     "isLodgingCovered",
            "baseName": "isLodgingCovered",
            "type":     "string"
        },
        {
            "name":     "lodgingServicePhoneNumber",
            "baseName": "lodgingServicePhoneNumber",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return MedicalBiTransportationService.attributeTypeMap;
    }
}
